import React from 'react'
import { useTranslation } from 'react-i18next'
import InputField from '../../../../../component/formFields/InputField'
import EditableImage from '../../../../../component/EditableImage'
import { useLoadImg } from '../../../../../hooks/useLoadImg'
import SectionCard from '../shared/SectionCard'
import './style.css'

const EditBasicInformation = ({ formHandler, providerInfo , isLoading }) => {
    const { t } = useTranslation()
    const { img: providerLogo } = useLoadImg("", providerInfo?.logo, "./images/profile-img.jpg")

    return (
        <SectionCard 
            title={t("basic-information")} 
            icon="mdi:hospital-building"
            className="edit-basic-info"
        >
            <div className="edit-form-grid">
                <div className="full-width">
                    <EditableImage 
                        formHandler={formHandler} 
                        name={"Logo"} 
                        label={"Logo"} 
                        defaultValue={providerLogo}
                    />
                </div>

                <InputField 
                    isLoading={isLoading}
                    formHandler={formHandler} 
                    name={"providerName"} 
                    defaultValue={providerInfo?.providerName}
                />

                <InputField 
                    isLoading={isLoading}
                    formHandler={formHandler} 
                    name={"profileSummary"} 
                    defaultValue={providerInfo?.profileSummary}
                />
            </div>
        </SectionCard>
    )
}

export default EditBasicInformation

